// Module
var code = " <mat-checkbox *ngIf=\"editable\" [disabled]=\"!enabled\" [color]=\"color\" [checked]=\"checked\" (change)=\"onChange($event.checked)\">{{ label }}</mat-checkbox> <mat-icon *ngIf=\"!editable &amp;&amp; checked\" svgIcon=\"gh:done\"></mat-icon>";
// Exports
module.exports = code;